import { useEffect, useState } from 'react';
import { AText, Box } from '@alf/uikit';
import { useOtherSettings } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';

import styles from './index.module.css';

const CookieBotData = () => {
  const { t } = useI18n();
  const { cookieManagement = {} } = useOtherSettings();
  const { isCookieBotEnabled = false } = cookieManagement;
  const [cookieBotDate, setCookieBotDate] = useState(null);
  const [cookieBotId, setCookieBotId] = useState(null);
  const { consentUTC: cookieConsentUTC, consentID: cookieConsentID } =
    window.Cookiebot || {};

  const updateCookieBotData = () => {
    const { consentUTC, consentID } = window.Cookiebot || {};
    setCookieBotDate(consentUTC);
    setCookieBotId(consentID);
  };

  useEffect(() => {
    if (isCookieBotEnabled) {
      const handleCookiebotLoad = () => {
        updateCookieBotData();
      };

      window.addEventListener('CookiebotOnLoad', handleCookiebotLoad);

      return () => {
        window.removeEventListener('CookiebotOnLoad', handleCookiebotLoad);
      };
    }

    return undefined;
  }, [isCookieBotEnabled]);

  if (!isCookieBotEnabled) {
    return null;
  }

  return (
    <Box className={styles.wrapper} direction="column">
      {(cookieConsentUTC || cookieBotDate) && (
        <Box direction="column" className={styles.text}>
          <AText breed="B">{t('web.cookieBot.data')}</AText>
          <AText>
            {cookieConsentUTC?.toString() || cookieBotDate?.toString()}
          </AText>
        </Box>
      )}
      {((cookieConsentID && cookieConsentID !== '0') ||
        (cookieBotId && cookieBotId !== '0')) && (
        <Box direction="column">
          <AText breed="B">{t('web.cookieBot.id')}</AText>
          <AText>{cookieConsentID || cookieBotId}</AText>
        </Box>
      )}
    </Box>
  );
};

export default CookieBotData;
